import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2
      className="text-white uppercase mb-5 border-b border-yellow-400 pb-3"
      style={{
        fontFamily: "'BebasNeue-Book', sans-serif",
        fontSize: "clamp(24px, 2.5vw, 34px)",
        letterSpacing: "0.04em",
        lineHeight: "1.1"
      }}
    >
      {title}
    </h2>
    <div
      className="text-gray-300 space-y-4"
      style={{
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 300,
        fontSize: "0.97rem",
        lineHeight: "1.75",
        letterSpacing: "0.01em"
      }}
    >
      {children}
    </div>
  </section>
);

const Item = ({ num, children }) => (
  <p>
    <span className="text-yellow-400 mr-2" style={{ fontFamily: "'BebasNeue-Book', sans-serif" }}>{num}</span>
    {children}
  </p>
);

const RegulamentoInterno = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />

      <PageHeader
        title="REGULAMENTO INTERNO"
        subtitle="Normas de funcionamento e condições de utilização do estúdio."
        backgroundImage=""
        overlayOpacity={1}
      />

      <article className="py-16 sm:py-20 md:py-24 bg-black" data-testid="regulamento-content">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">

          <p
            className="text-gray-300 mb-6"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 300,
              fontSize: "0.97rem",
              lineHeight: "1.75"
            }}
          >
            O presente Regulamento Interno define as regras de utilização do espaço ULTIMATE FIT — Estúdio de Treino, operado por Rui F. Marques e Manuel J. Gonzalez.
          </p>
          <p
            className="text-gray-300 mb-12"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 300,
              fontSize: "0.97rem",
              lineHeight: "1.75"
            }}
          >
            A utilização das instalações implica a aceitação integral das presentes normas.
          </p>

          <Section title="1 — Modelo de funcionamento">
            <Item num="1.1">
              O ULTIMATE FIT é um espaço de treino onde operam profissionais de fitness independentes.
            </Item>
            <Item num="1.2">
              Os serviços de treino personalizado são prestados por Personal Trainers autónomos, sendo da sua responsabilidade a gestão dos seus clientes, incluindo preços, pagamentos e condições.
            </Item>
            <Item num="1.3">
              As aulas de grupo são organizadas no âmbito do ULTIMATE FIT.
            </Item>
          </Section>

          <Section title="2 — Acesso e utilização do espaço">
            <Item num="2.1">
              A utilização das instalações é permitida apenas durante sessões de treino ou aulas devidamente agendadas.
            </Item>
            <Item num="2.2">
              O acesso ao estúdio pressupõe o cumprimento das regras de utilização e o respeito pelos restantes utilizadores e profissionais.
            </Item>
            <Item num="2.3">
              O número máximo de pessoas em treino simultâneo é limitado a 6 (seis), por razões de segurança, qualidade e conforto.
            </Item>
            <Item num="2.4">
              Os profissionais que utilizam o espaço são responsáveis por garantir o cumprimento deste limite no planeamento das suas sessões.
            </Item>
          </Section>

          <Section title="3 — Marcações e pontualidade">
            <Item num="3.1">
              Todas as sessões e aulas funcionam mediante marcação prévia.
            </Item>
            <Item num="3.2">
              A não comparência injustificada poderá condicionar futuras marcações.
            </Item>
            <Item num="3.3">
              O cancelamento de sessões deverá ser efetuado com antecedência mínima de 12 horas, salvo indicação diferente do respetivo profissional.
            </Item>
            <Item num="3.4">
              A pontualidade deve ser respeitada, podendo ser recusada a entrada após o início da sessão ou aula.
            </Item>
          </Section>

          <Section title="4 — Normas de utilização">
            <Item num="4.1">
              É obrigatória a utilização de toalha durante os treinos.
            </Item>
            <Item num="4.2">
              É obrigatório o uso de calçado adequado.
            </Item>
            <Item num="4.3">
              Os equipamentos devem ser utilizados de forma responsável e higienizados após utilização.
            </Item>
            <Item num="4.4">
              Não é permitido o uso de telemóvel durante aulas de grupo, salvo indicação do instrutor.
            </Item>
            <Item num="4.5">
              Não é permitido o consumo de alimentos na área de treino.
            </Item>
          </Section>

          <Section title="5 — Segurança e responsabilidade">
            <Item num="5.1">
              Cada Personal Trainer é responsável por assegurar o seguro de acidentes pessoais dos seus clientes.
            </Item>
            <Item num="5.2">
              O ULTIMATE FIT não se responsabiliza por lesões decorrentes da prática de exercício no âmbito de treinos personalizados.
            </Item>
            <Item num="5.3">
              O cliente deve informar o profissional sobre qualquer limitação física ou condição de saúde relevante.
            </Item>
            <Item num="5.4">
              Recomenda-se a consulta de um profissional de saúde antes do início da prática de exercício físico.
            </Item>
          </Section>

          <Section title="6 — Comportamento">
            <Item num="6.1">
              Todos os utilizadores devem manter uma conduta respeitosa para com outros clientes e profissionais.
            </Item>
            <Item num="6.2">
              Não são permitidos comportamentos agressivos, linguagem ofensiva ou atitudes que perturbem o funcionamento do espaço.
            </Item>
            <Item num="6.3">
              Não é permitido o acesso sob efeito de álcool ou substâncias ilícitas.
            </Item>
            <Item num="6.4">
              O incumprimento destas normas poderá resultar na suspensão ou exclusão do acesso ao estúdio.
            </Item>
          </Section>

          <Section title="7 — Aulas de grupo">
            <Item num="7.1">
              As aulas de grupo estão sujeitas a marcação prévia e limite de vagas.
            </Item>
            <Item num="7.2">
              O ULTIMATE FIT poderá ajustar horários e tipologia de aulas sempre que necessário.
            </Item>
            <Item num="7.3">
              As condições específicas (cancelamentos, packs, validade) são comunicadas no momento da inscrição.
            </Item>
          </Section>

          <Section title="8 — Bens pessoais">
            <Item num="8.1">
              O ULTIMATE FIT não se responsabiliza por furtos, perdas ou danos de objetos pessoais no interior das instalações.
            </Item>
          </Section>

          <Section title="9 — Disposições gerais">
            <Item num="9.1">
              O ULTIMATE FIT reserva-se o direito de alterar o presente regulamento sempre que necessário.
            </Item>
            <Item num="9.2">
              As alterações serão comunicadas no estúdio ou através do website.
            </Item>
            <Item num="9.3">
              A utilização do espaço implica a aceitação destas regras.
            </Item>
          </Section>

          <div className="pt-8 mt-12 border-t border-gray-800">
            <p
              className="text-gray-400 italic"
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 300,
                fontSize: "0.9rem"
              }}
            >
              ULTIMATE FIT — Estúdio de Treino · Última atualização: 2026
            </p>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default RegulamentoInterno;
